import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/customer-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const status = (id, data) => {
    return httpClient
        .post(`/api/customer-profiles/${id}/change-status`, data)
}

export default { get, status }